// React
import React from 'react';
import classNames from 'classnames';
// Components
import ClockIcon from '../icons/clock-icon';
// Styles
import useStyles from './PartnerNextInterval.styles';

export const intervalTypes = {
  NEXT: 'NEXT',
  TODAY: 'TODAY',
};

const PartnerNextInterval = ({ classes, nextInterval }) => {
  const componentClasses = useStyles();
  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <ClockIcon />
      <div
        className={classNames(
          componentClasses.nextInterval,
          classes.nextInterval,
        )}
      >
        <span>{nextInterval}</span>
      </div>
    </div>
  );
};

PartnerNextInterval.defaultProps = {
  classes: {},
};

export default PartnerNextInterval;
